module.exports = __webpack_public_path__ + "assets/img/02.c291d9e2.jpg";